Vue.component("asset-update-form", {

    props: {
        asset: {},
        assetGroups: {}
    },

    data () {
        return {
            mandateTypes: ["unspecified", "managed", "unmanaged"],
            form: new AppForm({
                notes: this.asset.notes,
                asset_name: this.asset.name,
                portfolio: this.asset.portfolio_id,
                asset_group: this.asset.asset_group_id,
                current_mandate_type: this.asset.current_mandate_type === null ? "unspecified" : this.asset.current_mandate_type,
                prevent_external_updates: this.asset.prevent_external_updates
            })
        };
    },

    computed: {
        mandateTypeLabel () {
            return _.startCase(this.form.current_mandate_type);
        },
    },

    methods: {

        saveAsset () {

            App.patch("/assets/" + this.asset.id + "/update", this.form)
            .then((response) => {
                Bus.$emit("asset-updated", response);
                window.toastr.success("Saved!");
            });

        },

        assetGroupChanged () {
            // Stub
            return;
        }

    }

});
